import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AccountService } from '@infodocs/shared/services/account.service';

@Injectable({
	providedIn: 'root',
})
export class BillingAccessGuard implements CanActivate {
	private readonly accountService = inject(AccountService);
	private readonly router = inject(Router);

	canActivate(): boolean | UrlTree {
		if (!this.accountService.canAccessBilling()) {
			return this.router.createUrlTree(['/account']);
		}

		return true;
	}
}
